import { Box, Divider, Grid, Typography } from "@material-ui/core";
import { CardProdutoProps } from "./card-produto-props"
import { useStyles } from "./card-produto-entrega-style";
import { toDecimalString } from "../../../../../../utils/to-decimal";
import { useThemeQueries } from "../../../../../theme";
import { EnumTpProduto } from "../../../../../../model/enums/enum-tp-produto";

export const CardProduto = (props: CardProdutoProps) => {

    const classes = useStyles();
    const { theme } = useThemeQueries()

    const { model, ultimoIndex } = props

    return (
        <>
            <Grid container>
                <Grid item xs={12} style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <Grid container>
                        <Grid item xs={7} style={{
                            display: 'flex',
                            alignItems: 'center',
                            paddingTop: '4px',
                            paddingBottom: '4px',
                        }}>
                            <Typography
                                variant="body2"
                                color="textPrimary"
                                className={classes.tresPontinhos}
                            >
                                <Box fontWeight={500}>
                                    {model.descricao}
                                </Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={2} style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end'
                        }}>
                            <Typography
                                variant="body2"
                                color="textPrimary"
                            >
                                <Box fontWeight={600}>
                                    {`${props.model.quantidade} UN`}
                                </Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={3} style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end'
                        }}>
                            <Typography
                                variant="body2"
                                color="textPrimary"
                            >
                                <Box fontWeight={600}>
                                    {`R$ ${toDecimalString(props.model.valorTotal)}`}
                                </Box>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>


                {
                    model?.adicionais?.length > 0 && (
                        <>
                            <Typography variant="body1" style={{ fontSize: 12 }}>{model.tpProduto.codigo !== EnumTpProduto.Combo ? 'Adicionais' : 'Composição'}</Typography>
                            <Divider className={classes.divider} />
                        </>
                    )
                }
                {
                    model?.adicionais?.length > 0 && model.adicionais.map((p, index) => (
                        <Grid key={index}>
                            <Typography>{p.quantidade}X {p.descricao}</Typography>
                        </Grid>
                    ))
                }
                {!ultimoIndex && (
                    <Grid item xs={12}>
                        <Divider variant="fullWidth" style={{ background: theme.palette.grey[200] }} />
                    </Grid>
                )}
            </Grid >
        </>
    )
}